module.exports = __webpack_public_path__ + "static/Customize-Colours-1a-e1403553494504-12dfdeee834e28789a0221aaed8c9d1c.jpg";